import { AssetTypeOutputDTO } from '@types';

export const assetTypeMapper = {
  toDTO: (data: Partial<AssetTypeOutputDTO>): Partial<AssetTypeOutputDTO> => {
    return {
      ...data,
      data: data.data?.map((field) => ({
        ...field,
      })),
    };
  },

  toView: (data: AssetTypeOutputDTO): AssetTypeOutputDTO => {
    return data; // Por enquanto retorna o mesmo objeto, podemos expandir se necessário
  },
};
